import * as Mod1 from "./discourse/components/follow-button";
import * as Mod2 from "./discourse/components/follow-notification-preferences";
import * as Mod3 from "./discourse/components/follow-statistic";
import * as Mod4 from "./discourse/components/follow-users-list";
import * as Mod5 from "./discourse/connectors/user-card-additional-buttons/follow-button-container.gjs";
import * as Mod6 from "./discourse/connectors/user-card-metadata/follow-statistics-user-card.gjs";
import * as Mod7 from "./discourse/connectors/user-main-nav/follow-user-container.gjs";
import * as Mod8 from "./discourse/connectors/user-preferences-notifications/follow-notification-preferences-container.gjs";
import * as Mod9 from "./discourse/connectors/user-profile-controls/follow-button-container.gjs";
import * as Mod10 from "./discourse/connectors/user-profile-secondary/follow-statistics-user.gjs";
import * as Mod11 from "./discourse/controllers/follow";
import * as Mod12 from "./discourse/initializers/follow-initializer";
import * as Mod13 from "./discourse/models/post-stream";
import * as Mod14 from "./discourse/routes/feed";
import * as Mod15 from "./discourse/routes/follow";
import * as Mod16 from "./discourse/routes/follow/index";
import * as Mod17 from "./discourse/routes/followers";
import * as Mod18 from "./discourse/routes/following";
import * as Mod19 from "./discourse/templates/feed";
import * as Mod20 from "./discourse/templates/follow";
import * as Mod21 from "./discourse/templates/followers";
import * as Mod22 from "./discourse/templates/following";
import * as Mod23 from "./discourse/users-route-map";
const compatModules = {
  "discourse/components/follow-button": Mod1,
  "discourse/components/follow-notification-preferences": Mod2,
  "discourse/components/follow-statistic": Mod3,
  "discourse/components/follow-users-list": Mod4,
  "discourse/connectors/user-card-additional-buttons/follow-button-container": Mod5,
  "discourse/connectors/user-card-metadata/follow-statistics-user-card": Mod6,
  "discourse/connectors/user-main-nav/follow-user-container": Mod7,
  "discourse/connectors/user-preferences-notifications/follow-notification-preferences-container": Mod8,
  "discourse/connectors/user-profile-controls/follow-button-container": Mod9,
  "discourse/connectors/user-profile-secondary/follow-statistics-user": Mod10,
  "discourse/controllers/follow": Mod11,
  "discourse/initializers/follow-initializer": Mod12,
  "discourse/models/post-stream": Mod13,
  "discourse/routes/feed": Mod14,
  "discourse/routes/follow": Mod15,
  "discourse/routes/follow/index": Mod16,
  "discourse/routes/followers": Mod17,
  "discourse/routes/following": Mod18,
  "discourse/templates/feed": Mod19,
  "discourse/templates/follow": Mod20,
  "discourse/templates/followers": Mod21,
  "discourse/templates/following": Mod22,
  "discourse/users-route-map": Mod23,
};
export default compatModules;
